import { Screens } from "@/screens";
import { RouteObject } from "react-router-dom";

export const routes: Array<RouteObject> = [
  {
    path: "/",
    element: <Screens.Dashboard />,
  },
  {
    path: "/login",
    element: <Screens.SignIn />,
  },
  {
    path: "/logout",
    element: <Screens.SignOut />,
  },
  {
    path: "/account",
    element: <Screens.Account.Index />,
  },
  {
    path: "/account/pro",
    element: <Screens.Account.Pro />,
  },
  {
    path: "/session/duplicate/:sessionUuid",
    element: <Screens.Session.Duplicate />,
  },
  {
    path: "/search/:search",
    element: null,
  },
];
